<template>

  <v-jumbotron>
    <v-container fill-height>
      <v-layout align-center>
        <v-flex>
          <h4 class="display-2 my-3">
            You are now logged in.
          </h4>
          <v-divider></v-divider>
          <!-- <div class="title my-4">Confirm and continue</div> -->
          <!-- <v-btn :v-on:click="checkEmailVerificationState" large color="secondary" dark class="mx-0 my-3">Confim and continue</v-btn> -->
<!--           <v-btn to="/tour1" class="my-4" color="secondary">Confirm and continue</v-btn>
          <p v-if="!emailVerified" style="color:#ed831a">Your email is NOT yet verified. Please check your email, click the link there, and then refresh this page.</p> -->

        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>

</template>

<script>
  import firebase from 'firebase'

  export default {
    name: 'ConfirmLogin',
    data () {
      return {
        // foo: 'bar'
        emailVerified: null,
        user: null
        // gradient: '315deg, #3f87a6, #f69d3c',
      }
    },
    created () {
      // console.log('Fetching token...')
      // console.log('Token: ', this.idToken)
      this.user = firebase.auth().currentUser
      // console.log(this.user)
      this.emailVerified = firebase.auth().currentUser.emailVerified
    },
    mounted () {
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/User/ConfirmLogin.vue